import {
  DISPLAY_FONTSIZE_DECREASE,
  DISPLAY_FONTSIZE_INCREASE,
  DISPLAY_IS_EDIT_SET,
  DISPLAY_IS_ORIGIN_SET,
  DISPLAY_LEFT_SIDE_WIDTH_SET,
  DISPLAY_RIGHT_SIDE_WIDTH_SET,
} from "./constants";
import {
  DecreaseFontSize,
  IncreaseFontSize,
  SetIsEdit,
  SetIsOrigin,
  SetLeftSideWidth,
  SetRightSideWidth,
} from "./actionTypes";

export const decreaseFontSize = (): DecreaseFontSize => ({ type: DISPLAY_FONTSIZE_DECREASE });

export const increaseFontSize = (): IncreaseFontSize => ({ type: DISPLAY_FONTSIZE_INCREASE });

export function setIsEdit(payload: boolean): SetIsEdit {
  return ({
    type: DISPLAY_IS_EDIT_SET,
    payload,
  });
}

export const setIsOrigin = (payload: boolean): SetIsOrigin => ({
  type: DISPLAY_IS_ORIGIN_SET,
  payload,
});

export function setLeftSideWidth(payload: number): SetLeftSideWidth {
  return ({
    type: DISPLAY_LEFT_SIDE_WIDTH_SET,
    payload,
  });
}

export function setRightSideWidth(payload: number): SetRightSideWidth {
  return ({
    type: DISPLAY_RIGHT_SIDE_WIDTH_SET,
    payload,
  });
}
